import React from 'react';
import { BsFillXCircleFill } from 'react-icons/bs';
import { NavLink } from 'react-router-dom';
import { Server } from '../../server/server';
import { getPortraitImage } from '../util/util';
import './Modal.css'
import './UserListModal.css'

interface UserListModalProps {
  open: boolean;
  title: string,
  users: string[];
  profile?: boolean;
  onClose: Function;
}

class UserListModal extends React.Component<UserListModalProps, {}> {
  render() {
    if(!this.props.open)
      return (<div></div>);

    let sortedProfiles = [];
    for(let i = 0; i < this.props.users.length; i++) 
      sortedProfiles.push(Server.public.getProfile(this.props.users[i]));

    sortedProfiles.sort((a, b)=>{
      if(a.name > b.name)
        return 1;
      else if(a.name < b.name)
        return -1;
      return 0;
    })

    let userDivs:any[] = [];
    for(let i = 0; i < sortedProfiles.length; i++) {
      let profile = sortedProfiles[i];
      let portrait = getPortraitImage(profile);
      if(this.props.profile) {
        userDivs.push(
          <NavLink key={i.toString()} className="user-list-modal-row" to={'/profile/' + profile.slug} onClick={()=>this.props.onClose(profile.slug)}>
            <img className="user-list-modal-portrait" src={portrait} />
            <div>{profile.name}</div>
          </NavLink>
        );
      }
      else {
        userDivs.push(
          <div key={i.toString()} className="user-list-modal-row" onClick={()=>this.props.onClose(profile.id)}>
            <img className="user-list-modal-portrait" src={portrait} />
            <div>{profile.name}</div>
          </div>
        );
      }
    }

    return (
      <div className="modal open">
        <div className="modal-content user-list-modal-content">
          <button className="modal-close-button" onClick={()=>this.props.onClose()}>
            <BsFillXCircleFill />
          </button>
          <div className="user-list-modal-header">{this.props.title}</div>
          {this.props.users.length == 0 ?
            <div>Loading...</div> :
            <div className="user-list-modal-container">
              {userDivs}
            </div>
          }
        </div>
      </div>
    )
  }
}

export default UserListModal;